const API_URL = process.env.REACT_APP_BACKEND_URL;

function gtag() {
  if (window.gtag) window.gtag(...arguments);
}

function getVisitorId() {
  let id = localStorage.getItem('ilc_vid');
  if (!id) {
    id = 'v_' + Math.random().toString(36).substring(2) + Date.now().toString(36);
    localStorage.setItem('ilc_vid', id);
  }
  return id;
}

function getUtmParams() {
  const params = new URLSearchParams(window.location.search);
  const utm = {};
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(key => {
    const val = params.get(key);
    if (val) utm[key] = val;
  });
  if (Object.keys(utm).length > 0) {
    sessionStorage.setItem('ilc_utm', JSON.stringify(utm));
  }
  return JSON.parse(sessionStorage.getItem('ilc_utm') || '{}');
}

export function trackPageView(path) {
  gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
  });

  const utm = getUtmParams();
  fetch(`${API_URL}/api/analytics/pageview`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Visitor-Id': getVisitorId() },
    body: JSON.stringify({ path, referrer: document.referrer || '', utm }),
  }).catch(() => {});
}

export function trackEvent(eventName, params = {}) {
  gtag('event', eventName, params);

  fetch(`${API_URL}/api/analytics/event`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Visitor-Id': getVisitorId() },
    body: JSON.stringify({ event: eventName, params, path: window.location.pathname }),
  }).catch(() => {});
}

// Pre-defined conversion events
export const analytics = {
  quizComplete: (track, major) => trackEvent('quiz_complete', { track, major }),
  leadCapture: (source, email) => trackEvent('lead_capture', { source, email_domain: email.split('@')[1] }),
  ctaClick: (ctaName, location) => trackEvent('cta_click', { cta_name: ctaName, location }),
  signUp: () => trackEvent('sign_up'),
  login: () => trackEvent('login'),
  paymentStart: () => trackEvent('begin_checkout'),
  paymentComplete: (value) => trackEvent('purchase', { value, currency: 'USD' }),
  bridgePreview: (major) => trackEvent('bridge_preview', { major }),
  zipAnalysis: (zip) => trackEvent('zip_analysis', { zip }),
  chatOpen: () => trackEvent('chat_open'),
  resourceDownload: (guide) => trackEvent('resource_download', { guide }),
  scrollDepth: (percent) => trackEvent('scroll_depth', { percent }),
  // Conversion & trust instrumentation
  ctaPlatformStart: (location) => trackEvent('cta_platform_start_click', { location }),
  ctaStrategyCall: (location) => trackEvent('cta_strategy_call_click', { location }),
  ctaEliteApply: (location) => trackEvent('cta_elite_apply_click', { location }),
  diagnosticStart: () => trackEvent('diagnostic_start'),
  diagnosticComplete: (recommendation, totalScore) => trackEvent('diagnostic_complete', { recommendation, total_score: totalScore }),
  proofModuleView: (location) => trackEvent('proof_module_view', { location }),
  testimonialExpand: (index) => trackEvent('testimonial_expand', { index }),
  resultsPageView: () => trackEvent('results_page_view'),
  portalUpgradePromptClick: (context) => trackEvent('portal_upgrade_prompt_click', { context }),
};
